import { LimitationType } from 'store/limitations/limitationsSlice';
import { convertDigitToProperFormat } from '../../../utils/number';
import i18n from '../../../i18n';

export default {
  LIMITED_TO_COMPANY_MEMBERS: 'اعضای مجموعه',
  indicatorItem: 'شاخص',
  analyseItem: 'تحلیل شاخص',
  accessSameAsParentFolder: 'سطح دسترسی همانند پوشهٔ والد',
  canAccessByYou: 'تنها در دسترس شما',
  changeData: 'تغییر داده‌ها',
  edit: 'ویرایش',
  enterPhoneNumberOrName: 'نام یا‌ موبایل فرد مورد نظر را وارد کنید...',
  addLimitationByName:
    'برای اضافه کردن دسترسی به کاربران، می‌توانید نام آن‌ها را جستجو کرده و دسترسی مورد نظر را به آن‌ها بدهید.',
  addLimitationByNameAndNumber:
    'برای دادن دسترسی به کاربران، ‌می‌توانید نام یا شماره تلفن آن‌ها را جستجو کرده و دسترسی مورد نظر را به آن‌ها بدهید.',
  fromParent: 'دسترسی از والد',
  publicAccessible: 'در دسترسی عموم جهت مشاهده',
  activePermissions: 'دسترسی‌های این سند',
  addRoleOrUser: 'افزودن کاربر یا سمت به دسترسی‌ها',
  userToRoleMigration: 'انتقال دسترسی‌های شخص به نقش',
  migrateLimitations: 'انتقال دسترسی',
  addMigrateLimitationsToList: 'افزودن به لیست',
  readLimitationExists:
    'امکان مشاهده این سند محدود گردیده و مطابق لیست زیر است',
  readLimitationNotExistsButLimited:
    'امکان مشاهده این سند - در یکی از پوشه‌های دربرگیرنده - محدود گردیده و مطابق لیست زیر است',
  publicAccessibleFromParent:
    'در حال حاضر، دسترسی مشاهده این سند برای عموم باز است. در صورت نیاز به محدود کردن دسترسی مشاهده ، دکمه «محدودیت دسترسی مشاهده» را فعال نموده و افراد مورد نظر را انتخاب نمایید.',
  limitation: 'سطح دسترسی',
  choosePermission: 'انتخاب دسترسی',
  permissionIsFromParent:
    'این دسترسی در پوشه دربرگیرنده تعریف شده است و امکان ویرایش آن در اینجا وجود ندارد',
  publiAccess: 'دسترسی عموم',
  fillProtectedTarget_ShowToTarget: 'مشاهده پاسخ‌های مرتبط با خود',
  invalidFill: '-',
  fillPersonalTarget_ShowToTarget: 'ثبت و مشاهده داده شخصی',
  fillPersonalTarget: 'ثبت داده شخصی',
  fillPublic: 'مشاهده و ارسال داده',
  saved: 'مهاجرت دسترسی‌ها انجام شد.',
  inactive: 'غیر فعال',
  name: 'سمت / فرد',
  passwordChanged: 'کد عبور تغییر کرد',
  preserveParentEditLimitation: 'محدودیت دسترسی همانند پوشه‌ی والد باشد',
  public: 'در دسترس عموم',
  view: 'مشاهده',
  report: 'گزارش',
  savePassCode: 'ذخیره کد عبور',
  searchUser: 'جستجوی کاربر',
  userNotFound: 'کاربر مورد نظر پیدا نشد',
  givePermissionToUsers: 'انتخاب از بین کاربران',
  givePermissionToRoles: 'انتخاب از بین نقش‌ها',
  selectACompanyRole: 'انتخاب سمت...',
  selectAUser: 'انتخاب کاربر...',
  roleMigrationHint:
    'با انتخاب یک کاربر و یک نقش، می‌توانید دسترسی‌های کاربر را به آن نقش منتقل کنید. این انتقال در کل دسترسی های اسناد انجام می‌شود',
  userPermission: 'دسترسی‌های',
  forRole: 'به سمت',
  beenCopied: 'منتقل شود',
  otherPathView(count: number) {
    return i18n.t('otherPathView', {
      ns: 'documentManager',
      formattedCount: convertDigitToProperFormat(count.toString()),
    });
  },
  companyAccessibleFromParent: (companyName: string) =>
    `در حال حاضر دسترسی مشاهده این سند برای کلیه اعضای ${companyName} باز است در صورت نیاز به محدود کردن دسترسی مشاهده ، دکمه «محدودیت دسترسی مشاهده» را فعال نموده و افراد مورد نظر را انتخاب نمایید. `,

  companyAccessible: (companyName: string | undefined) =>
    `در دسترسی اعضا ${companyName || ''} جهت مشاهده`,

  allMembers: (companyName: string | undefined) =>
    i18n.t('allMembers', {
      ns: 'documentManager',
      companyName: companyName || '',
    }),

  searchInCompany(companyName: string) {
    return i18n.t('searchInCompany', { ns: 'documentManager', companyName });
  },
  permissionMessage: (
    preserveParent: boolean,
    _type: LimitationType,
    exceptedUsersCount?: string,
    exceptedRolesCount?: string,
    enabled?: boolean
  ) => {
    const likeParent = 'همانند پوشه‌ی والد';
    const canAccessByYOu = 'در دسترس شما';
    const baseAccess = preserveParent ? likeParent : canAccessByYOu;
    if (exceptedUsersCount && exceptedRolesCount) {
      return `${baseAccess} و ${exceptedUsersCount} و ${exceptedRolesCount} دیگر`;
    }
    if (exceptedUsersCount && !exceptedRolesCount) {
      return `${baseAccess} و ${exceptedUsersCount} دیگر`;
    }
    if (!exceptedUsersCount && exceptedRolesCount) {
      return `${baseAccess} و ${exceptedRolesCount} دیگر`;
    }
    if (preserveParent) {
      return likeParent;
    }
    if (_type === 'read') {
      if (enabled) {
        return canAccessByYOu;
      } else {
        return likeParent;
      }
    } else {
      return canAccessByYOu;
    }
  },
  usersCount(count: string) {
    return `${count} نفر`;
  },
  rolesCount(count: string) {
    return `${count} نقش`;
  },
  permissionTitle: (type: LimitationType) => {
    return `محدودیت ${getPermissionTitle[type]}`;
  },
};

export const getPermissionTitle: { [key in LimitationType]: string } = {
  edit: 'ویرایش',
  read: 'مشاهده',
  report: 'گزارش',
  changeData: 'تغییر داده‌ها',
};
